import './styles/style.css';
import './styles/app.sass';
import './styles/fonts.css';
import 'vuejs-noty/dist/vuejs-noty.css'

import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueMeta from 'vue-meta';
import _ from 'underscore';
import VueNoty from 'vuejs-noty';

import App from './App.vue';
import storeData from './store.js';

Vue.use(VueRouter);
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueNoty);

const store = new Vuex.Store(storeData);

const Home = () => import(`./screens/Home.vue`);
const Form = () => import(`./screens/Form.vue`);
const Search = () => import(`./screens/Search.vue`);
const ConfirmForm = () => import(`./screens/ConfirmForm.vue`);
const Booking = () => import(`./screens/Booking.vue`);
const Datetime = () => import(`./screens/Datetime.vue`);
const Reminder = () => import(`./screens/Reminder.vue`);

const router = new VueRouter({
  routes: [
    {
      'path': '/',
      'name': 'Home',
      'component': Home,
    },
    {
      'path': '/form',
      'name': 'Form',
      'component': Form,
    },
    {
      'path': '/search',
      'name': 'Search',
      'component': Search,
    },
    {
      'path': '/confirm_form',
      'name': 'ConfirmForm',
      'component': ConfirmForm,
    },
    {
      'path': '/datetime',
      'name': 'Datetime',
      'component': Datetime,
    },
    {
      'path': '/reminder',
      'name': 'Reminder',
      'component': Reminder,
    },
    {
      'path': '/booking/:bookingId',
      'name': 'Booking',
      'component': Booking,
    },
  ],
  scrollBehavior(to) {
    if(to.hash === '') {
      document.getElementById('app').scrollIntoView();
    } else {
      $(document).scrollTop($(to.hash).offset().top);
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
